import React from "react";
import "./Styles/Styles.scss";
import { useNavigate } from "react-router";

function PageForbidden() {
  let navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="container-xxl pt-5 mt-5">
        <div className="row g-0 w-100">
          <div className="container w-50 justify-self-center text-center justify-content-center align-items-center">
            <div className="row g-0 w-100 mt-5 pt-5 text-center">
              <span className="page-404-text">403 Forbidden</span>
              <span className="content-not-found-text">
                Sorry, you are not authorized to access this page.
              </span>
              <div className="row g-0 w-100">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-lg btn-class mt-3"
                    onClick={() => navigate("/invest")}
                  >
                    Go Home
                  </button>
                  <button
                    type="button"
                    className="btn btn-lg page-404-button mt-3 ms-3"
                  >
                    {" "}
                    Contact us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default PageForbidden;
